/** @jsxImportSource @emotion/react */
import { useState, useEffect, useRef } from "react";
import { Outlet, useParams, useLocation } from "react-router-dom";
import { Toast } from "primereact/toast";
import { accessAPI, NavLateral, tituloBase } from "../../../shared/index.js";
import { useContextoAsistente } from "../../asistente/ContextoAsistente";

/**
 * Layout para la sección de detalle del proceso. Hace un único fetch del
 * proceso (con productos, actividades, certificado, etc.) y lo expone a las
 * subrutas vía Outlet context. Renderiza la botonera lateral con las 4
 * secciones: detalles, productos, actividades y certificado.
 */
export default function ProcesoLayout() {
  const { procesoId } = useParams();
  const { search } = useLocation();
  const [proceso, setProceso] = useState();
  const [loader, setLoader] = useState(true);
  const toast = useRef(null);
  useContextoAsistente({ tipo: "proceso", id: procesoId, nombre: proceso?.nombre });

  useEffect(() => {
    if (!procesoId) return;
    accessAPI(
      "GET",
      `admin/proceso/${procesoId}`,
      null,
      (respuesta) => {
        setProceso(respuesta);
        setLoader(false);
        // El nombre guardado, no la fórmula. Recomponerla acá mostraba el
        // nombre viejo en cuanto el organismo definía su propia numeración.
        document.title = respuesta.nombre;
      },
      (respuesta) => {
        setLoader(false);
        toast.current?.show({
          severity: "error",
          summary: "Error",
          detail: respuesta[0]?.msg || "Error al cargar el proceso",
          sticky: true
        });
      }
    );
    return () => (document.title = tituloBase());
  }, [procesoId]);

  const certificadoEmitidoId = proceso?.certificado?.[0]?.id;
  // Preserva los query params actuales (ej. ?volver=...) al navegar entre las
  // secciones del proceso desde el menú lateral.
  const navItems = [
    {
      icono: "pi pi-info-circle",
      etiqueta: "Detalles",
      to: `/proceso/${procesoId}/detalles${search}`
    },
    {
      icono: "pi pi-box",
      etiqueta: "Productos",
      to: `/proceso/${procesoId}/productos${search}`
    },
    {
      icono: "pi pi-list-check",
      etiqueta: "Actividades",
      to: `/proceso/${procesoId}/actividades${search}`,
      badge: proceso?.tieneAnalisisIAPendiente ? 1 : null
    },
    {
      icono: "pi pi-verified",
      etiqueta: "Certificado",
      to: certificadoEmitidoId
        ? `/proceso/${procesoId}/certificado/${certificadoEmitidoId}${search}`
        : `/proceso/${procesoId}/certificado${search}`
    }
  ];

  return (
    <div
      css={{
        // Espacio abajo para no quedar debajo de la botonera mobile
        "@media (max-width: 767px)": {
          paddingBottom: "5em"
        }
      }}
    >
      <Toast ref={toast} position="top-center" />
      <NavLateral items={navItems} />
      <Outlet context={{ proceso, setProceso, loading: loader }} />
    </div>
  );
}
